import React from "react";
import { Input, Textarea } from "@swordsweeper/ssi-ui-component-library";
import * as Yup from "yup";

export const schema = Yup.object().shape({
  email: Yup.string().required(),
  message: Yup.string().required(),
});

interface FormData {
  email: string;
  message: string;
}

interface HelpRequestFormProps {
  formData: FormData;
  onChange: (params: { name: keyof FormData; value: string }) => void;
}

export default function HelpRequestForm({
  formData,
  onChange,
}: HelpRequestFormProps): React.JSX.Element {
  return (
    <>
      <Input
        defaultValue=""
        onChange={(value: string) => onChange({ name: "email", value })}
        label="Email Address"
        value={formData.email}
        width="100%"
        required
      />
      <Textarea
        height="220px"
        label="Your Message"
        placeholder="Tell us all about it..."
        width="100%"
        onChange={(value: string) => onChange({ name: "message", value })}
        value={formData.message}
        resizable={false}
      />
    </>
  );
}
